import script from "./headermenu.vue?vue&type=script&setup=true&lang=js"
export * from "./headermenu.vue?vue&type=script&setup=true&lang=js"

import "./headermenu.vue?vue&type=style&index=0&id=27430e64&scoped=true&lang=css"

import exportComponent from "C:\\GigLabs\\CIMS\\CIMS-AfyunProd\\gig.ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27430e64"]])

export default __exports__